<template>
  <v-dialog v-model="opened">
    <v-card class="basic-modal" elevation="4" width="560">
      <v-card-title class="d-flex justify-space-between">
        <h6 class="heading--text d-flex align-center">
          <v-icon size="24" class="mr-4" color="error"> $alertwarning </v-icon>
          <span>
            {{ $t("heading.instance.advanced.users.modal.delete.title") }}</span
          >
        </h6>
        <v-btn v-if="!submitting" icon x-small @click="close()">
          <v-icon size="24">$close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div>
          <p v-if="user && user.email" class="mb-4 p-2">
            {{
              $t("heading.instance.advanced.users.modal.delete.message", {
                email: user.email,
              })
            }}
          </p>
          <v-form ref="form" class="d-flex flex-column">
            <div class="d-flex flex-column">
              <div class="last-child d-flex flex-column align-start w-100 pb-4">
                <template>
                  <template>
                    <p class="p-2">
                      <b>{{ $t("message.confirmAction") }}</b>
                    </p>
                    <label
                      class="base--text checkbox-label d-flex align-center p-2"
                    >
                      <Checkbox
                        outlined
                        @change="confirm = $event"
                        :label="$t('form.confirmDelete.user')"
                        color="primary"
                        dense
                      />
                    </label>
                  </template>
                </template>
              </div>
            </div>
          </v-form>
        </div>
      </v-card-text>

      <v-card-actions class="d-flex flex-wrap pb-4">
        <div class="w-100 pb-2">
          <v-btn
            :text="false"
            large
            block
            elevation="0"
            class="error"
            @click="submit()"
            :loading="submitting"
            :disabled="!confirm"
          >
            <span class="p-2 font-weight-600">{{ $t("button.delete") }}</span>
          </v-btn>
        </div>
        <div class="w-100 pb-2 cancel-btn">
          <v-btn
            :text="true"
            large
            block
            elevation="0"
            class="normal"
            @click="!submitting && close()"
          >
            <span class="p-2 font-weight-bold gray--text text--darken-1">
              {{ $t("button.cancel") }}
            </span>
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Api from "../../apis/Api";
import Checkbox from "@/components/buttons/Checkbox.vue";

export default {
  components: {
    Checkbox,
  },
  data() {
    return {
      opened: false,
      user: null,
      confirm: false,
      submitting: false,
    };
  },
  methods: {
    open(user) {
      this.opened = true;
      this.user = { ...user };
    },
    close() {
      this.opened = false;
    },
    submit() {
      this.submitting = true;
      Api.delete(`/reseller/users/${this.user.id}`)
        .then((response) => {
          this.$emit("user-deleted", response.data.data);
          this.close();
        })
        .catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
  watch: {
    // opened(opened) {
    //   if (opened) {
    //     this.$store.dispatch("lockBodyScroll");
    //     return;
    //   }
    //   this.$store.dispatch("unlockBodyScroll");
    // },
  },
};
</script>

<style src="@/components/modal/BasicModal.scss" lang="scss" scoped/>
